<ion-header>
  <ion-toolbar>
    <ion-title>Zprávy</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [scrollY]="false">
  <app-announcement-list
    *ngIf="activeTab === MessagingTabName.ANNOUNCEMENTS"
    [announcements]="announcements$ | async"
  ></app-announcement-list>

  <app-private-message-list-wrapper
    *ngIf="activeTab === MessagingTabName.PRIVATE_MESSAGES"
    [inboundMessages$]="inboundPrivateMessages$"
    [outboundMessages$]="outboundPrivateMessages$"
    (replyToMessage)="replyToPrivateMessage($event)"
    (loadInboundPrivateMessagesFromOffset)="service.inboundPrivateMessagesLoadOffset($event)"
    (loadOutboundPrivateMessagesFromOffset)="service.outboundPrivateMessagesLoadOffset($event)"
    (filterByAssistantId)="service.setAssistantFilter($event)"
    (filterByClientId)="service.setClientFilter($event)"
    (filterBySenderId)="service.setSenderFilter($event)"
    (fetchOnlyUnread)="service.setOnlyUnreadFilter($event)"
  ></app-private-message-list-wrapper>

  <app-sms-messages-list
    *ngIf="activeTab === MessagingTabName.SMS"
    [inboundMessages$]="inboundSmsMessages$"
    [outboundMessages$]="outboundSmsMessages$"
    [workgroups]="workgroups$ | async"
    (loadInboundSmsFromOffset)="smsLoadInboundOffset($event)"
    (loadOutboundSmsFromOffset)="smsLoadOutboundOffset($event)"
    (workgroupFilterChanged)="smsWorkgroupFilterChanged($event)"
    (messageRead)="smsMessageRead($event)"
    (markAllMessagesRead)="smsMessagesReadAll()"
  ></app-sms-messages-list>

  <app-client-messages-history-list
    *ngIf="activeTab === MessagingTabName.CLIENT_HISTORY"
    [messages]="clientOutboundMessages$ | async"
    [workgroups]="workgroups$ | async"
    (loadClientOutboundMessagesFromOffset)="clientOutboundMessagesLoadOffset($event)"
  ></app-client-messages-history-list>

  <app-message-editor
    #editor
    id="editor"
    slot="fixed"
    [show]="editorShown"
    [parentMode]="activeMsgMode"
    [users]="users$ | async"
    [currentUser]="currentUser$ | async"
    (closeClick)="hideEditor()"
    (sendMessage)="sendMessage($event)"
  ></app-message-editor>

  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button (click)="fabClicked()">
      <ion-icon [name]="fabState.icon"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons class="ion-buttons-center">
      <ion-tab-button
        (click)="switchTabTo(MessagingTabName.ANNOUNCEMENTS)"
        [selected]="activeTab === MessagingTabName.ANNOUNCEMENTS"
        [style.display]="!announcementsAllowed ? 'none' : null"
      >
        <ion-icon name="megaphone-outline"></ion-icon>
        <span>Nástěnka</span>
        <ng-container *ngIf="announcementsUnreadCount$ | async as announcementsUnreadCount">
          <ion-badge color="tertiary">{{ announcementsUnreadCount }}</ion-badge>
        </ng-container>
      </ion-tab-button>

      <ion-tab-button
        (click)="switchTabTo(MessagingTabName.PRIVATE_MESSAGES)"
        [selected]="activeTab === MessagingTabName.PRIVATE_MESSAGES"
      >
        <ion-icon name="mail-outline"></ion-icon>
        <span>Zprávy</span>
        <ng-container *ngIf="privateMessagesUnreadCount$ | async as privateMessagesUnreadCount">
          <ion-badge color="tertiary">{{ privateMessagesUnreadCount }}</ion-badge>
        </ng-container>
      </ion-tab-button>

      <ion-tab-button
        (click)="switchTabTo(MessagingTabName.SMS)"
        [selected]="activeTab === MessagingTabName.SMS"
        [style.display]="!smsAllowed ? 'none' : null"
      >
        <ion-icon name="phone-portrait-outline"></ion-icon>
        <span>Sms</span>
        <ng-container *ngIf="smsMessagesUnreadCount$ | async as smsUnreadCount">
          <ion-badge color="tertiary">{{ smsUnreadCount }}</ion-badge>
        </ng-container>
      </ion-tab-button>

      <ion-tab-button
        (click)="switchTabTo(MessagingTabName.CLIENT_HISTORY)"
        [selected]="activeTab === MessagingTabName.CLIENT_HISTORY"
        [style.display]="!clientHistoryAllowed ? 'none' : null"
      >
        <ion-icon name="time-outline"></ion-icon>
        <span>Klienti - odeslané maily</span>
      </ion-tab-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
